import { AppState } from 'app/store';
import { createSelector } from 'reselect';

export const getNotificationsList = (appState: AppState) =>
  appState.notifications.notifications;

export const getInvitesList = (appState: AppState) =>
  appState.notifications.invites;

export const getNotificationsLoadingState = (appState: AppState) =>
  appState.notifications.notificationsLoadingState;

export const getNotificationsNextLink = (appState: AppState) =>
  appState.notifications._notificationsListLinks?.next;

export const getNotificationsListLink = (appState: AppState) =>
  appState.auth.services?.notifications?._links?.listNotifications;

export const fetchUnseenNotificationLink = (appState: AppState) =>
  appState.auth.services?.notifications?._links?.getNewNotificationsCount?.href;

export const getUnseenNotificationCount = (appState: AppState) =>
  appState.notifications.newNotificationsCount;

export const getUnseenNotificationCountPollingInterval = (appState: AppState) =>
  appState.auth.services?.notifications?._links?.getNewNotificationsCount
    ?.pollingInterval;

export const getUnseenInviteLink = (appState: AppState) =>
  appState.auth.services?.invites?._links?.getNewInvitesCount?.href;

export const getUnseenInviteCount = (appState: AppState) =>
  appState.notifications.newInvitesCount;

export const getInvitationsListLink = (state: AppState) =>
  state.auth.services?.invites?._links.listInvites;

export const getInvitesNextLink = (appState: AppState) =>
  appState.notifications._invitesListLinks?.next;

export const getInvitesLoadingState = (state: AppState) =>
  state.notifications.invitesLoadingState;

export const getInvitesMoreLoadingState = (state: AppState) =>
  state.notifications.invitesMoreLoadingState;

export const getRespondToInviteLink = (appState: AppState) =>
  appState.notifications._invitesListLinks?.respondToInvite;

export const getMarkNotificationAsReadLink = (appState: AppState) =>
  appState.notifications._notificationsListLinks?.markNotificationAsRead;

export const getTranferInvitesLink = (state: AppState) =>
  state.auth.services?.invites?._links.transferInvite;

export const getInviteByTokenLink = (state: AppState) =>
  state.auth.services?.invites?._links.getInviteByToken;

export const getTotalNotificationsCount = (state: AppState) =>
  state.notifications.totalCount || 0;

export const getUnreadChatMessagesCount = (state: AppState) =>
  state.notifications.unreadChatMessagesCount;

export const getNewNotificationsCounts = createSelector(
  [
    getUnseenNotificationCount,
    getUnseenInviteCount,
    getTotalNotificationsCount,
    getUnreadChatMessagesCount,
  ],
  (notificationsCount, invitesCount, totalCount, unreadChatMessagesCount) => ({
    notificationsCount,
    invitesCount,
    totalCount,
    unreadChatMessagesCount,
    activityCount: notificationsCount,
  })
);
